import { DateObject } from '../../reusables/date-object';

/**
 * Blueprint for the event details part of ticketing object.
 */
export class TicketingEventDetails {
  public dateDetails: DateObject;
  public description: string;
  public competitionName: string;
  public homePerformer?: string;
  public guestPerformer?: string;
  public location: string;
  public name: string;

  constructor(data?: any) {
    this.dateDetails = new DateObject(data.date, 'EEEE, dd.MM.yyyy, HH:mm');
    this.description = data.description;
    this.competitionName = data.competitionName;
    this.homePerformer = data.homePerformer;
    this.guestPerformer = data.guestPerformer;
    this.location = data.location;
    this.name = data.name;
   }

  public getFormattedPerformers(): string {
    if (!this.homePerformer && !this.guestPerformer) {
      return this.name;
    }

    let formattedEventName: string = '';

    if (this.homePerformer) {
      formattedEventName = this.homePerformer;
    }

    if (this.homePerformer && this.guestPerformer) {
      formattedEventName = `${formattedEventName} - `;
    }

    if (this.guestPerformer) {
      formattedEventName = `${formattedEventName}${this.guestPerformer}`;
    }

    return formattedEventName;
  }
}
